import { Icon } from "../../../../core/icon";
export const MoveToolID = 'move';
export const createMoveTool = () => {
    return {
        id: MoveToolID,
        label: 'Move',
        icon: Icon.TOOL_PAN,
    };
};
createMoveTool.toolID = MoveToolID;
//# sourceMappingURL=moveTool.js.map